import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
	public isForm:boolean
  constructor(private _router:Router) { 

  }

  ngOnInit() {
  	this.isForm = ((this._router.url.indexOf('/proform/')>-1) || (this._router.url.indexOf('/officeform/')>-1));
  }

}
